import jwt_decode from 'jwt-decode';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {
  Component,
  OnInit,
  Renderer2
} from "@angular/core";

import { AuthService } from './shared/providers/auth/auth-service.service';
import { ConfirmationDialogService } from "./shared/providers/confirmation-dialog/confirmation-dialog.service";
import { FranchiseUserInfo } from './shared/models/models';
import { GoogleTagManagerService } from "./shared/providers/google-tag-manager.sevice";
import { LanguageUpdateService } from "./shared/providers/language/language.service";
import { OAuthService } from 'angular-oauth2-oidc';
import { TranslateService } from "@ngx-translate/core";
import { filter } from "rxjs/operators";
import { AppConfigService } from './shared/providers/config.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AppConsts } from './shared/app-consts';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  data: any;
  currentLang: string | null;
  copyright = "copyright";
  userInfo: FranchiseUserInfo = {};
  customHeader: boolean = false;
  customFooter: boolean = false;
  hasHeader: boolean = true;
  hasFooter: boolean = true;

  isLoading: boolean = false;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date | null = null;
  title = 'angular-idle-timeout';
isQrCodePage: boolean = false;
  constructor(
    config: AppConfigService,
    private authService: AuthService,
    private confirmationDialogService: ConfirmationDialogService,
    private _router: Router,
    public translate: TranslateService,
    router: ActivatedRoute,
    private renderer: Renderer2,
    private languageService: LanguageUpdateService,
    private googleTagManagerService: GoogleTagManagerService,
    private _oauthService: OAuthService,
    private idle: Idle,
  ) {

    this.authService.reConfigure(config);
    this.handleLanguageSession();
    this.handleIdleSession();
    this._router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: "page",
          pageName: item.url
        };

        this.googleTagManagerService.pushTag(gtmTag);
      }
    });

    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let child = router.root.firstChild?.snapshot;
        if (child && child.data) {
          this.customHeader =
            child.data['customHeader'];

          this.customFooter = child.data['customFooter'];
          this.hasHeader = child.data['hasHeader'] === false ? child.data['hasHeader'] : true;
          this.hasFooter = child.data['hasFooter'] === false ? child.data['hasFooter'] : true;

          // console.log("child.data", child.data);
          // console.log("hasHeader", this.hasHeader);
        } else {
          this.customHeader = false;
          this.customFooter = false;
          this.hasHeader = true;
          this.hasFooter = true;
        }
      });

    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(900);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(1);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      // this.idleState = 'No longer idle.'
      // console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      // this.idleState = 'Timed out!';
      // this.timedOut = true;
      // console.log(this.idleState);
      this._oauthService.logOut();
    });

    idle.onIdleStart.subscribe(() => {
      // this.idleState = 'You\'ve gone idle!'
      // console.log(this.idleState);
    });

    idle.onTimeoutWarning.subscribe(() => {
      // this.idleState = 'You will time out in ' + countdown + ' seconds!'
      // console.log(this.idleState);
    });
 this._router.events.pipe(
    filter(event => event instanceof NavigationEnd)
  ).subscribe((event: any) => {
    const isQrCodePage = event.url.includes('license-details');

    if (isQrCodePage) {
      this.hasHeader = false;
    } else {
      this.hasHeader = true;
      this.hasFooter = true;
    }
  });
  }

  handleLanguageSession() {

    let url = document.location.href;
    if (url.toLowerCase().includes('/ar/') || url.toLowerCase().includes('/ar?')) {
      const token: string | null = sessionStorage.getItem(AppConsts.Session_AccessToken);
      if (url.includes('/franchise-creation/payfort-confirm')) {

        sessionStorage.setItem(AppConsts.Session_PaymentUrl, url.slice(url.indexOf('/franchise-creation'), -12));
        if (url.toLowerCase().includes('?language=en')) {
          sessionStorage.setItem(AppConsts.Session_PaymentLang, 'en');
        }
      }
      if (!token) {//default
        this._oauthService.events.subscribe((res: { type: any }) => {
          switch (res.type) {
            case "token_received":

              const token: string | null = sessionStorage.getItem(AppConsts.Session_AccessToken);
              if (token) {
                this.userInfo = jwt_decode<FranchiseUserInfo>(token);
                this.currentLang = sessionStorage.getItem(AppConsts.Session_Lang);
                if (this.currentLang === "ar") {
                  const paymentLang: string | null = sessionStorage.getItem(AppConsts.Session_Lang);
                  if (paymentLang) {
                    this.currentLang = paymentLang;
                  }
                  else {
                    this.currentLang = 'ar';
                  }

                  sessionStorage.setItem(AppConsts.Session_Lang, this.currentLang);
                  this.setDefautLanguage(this.currentLang);
                  this.changeHtmlAttr(true);
                }
                else {
                  this.currentLang = 'en';
                  sessionStorage.setItem(AppConsts.Session_Lang, this.currentLang);
                  this.setDefautLanguage(this.currentLang);
                  this.changeHtmlAttr(false);
                }
              }
              break;
            default:
              break;
          }
        });
      }
      else {
        if (url.toLowerCase().includes('?language=en')) {
          this.currentLang = 'en';
          sessionStorage.setItem(AppConsts.Session_Lang, this.currentLang);
        }
        else {

          this.currentLang = 'ar';
          sessionStorage.setItem(AppConsts.Session_Lang, this.currentLang);
        }
      }
    }
    else if (url.toLowerCase().includes('/en/') || url.toLowerCase().includes('/en?')) {
      this.currentLang = 'en';
      sessionStorage.setItem(AppConsts.Session_Lang, this.currentLang);
    }
    else {

      this.currentLang = sessionStorage.getItem(AppConsts.Session_Lang);

      if (!this.currentLang) {
        this.currentLang = "ar"
        sessionStorage.setItem(AppConsts.Session_Lang, this.currentLang);
      }
    }

    if (this.currentLang) {

      this.setDefautLanguage(this.currentLang);
      if (this.currentLang === "ar") {
        this.changeHtmlAttr(true);
      } else if (this.currentLang === "en") {
        this.changeHtmlAttr(false);
      }
    }
  }

  handleIdleSession() {
    const token: string | null = sessionStorage.getItem(AppConsts.Session_AccessToken);
    if (!token) {//default
      this._oauthService.events.subscribe((res: { type: any }) => {
        switch (res.type) {
          case "token_received":
            this.initiateIdleWatch();
            break;
          default:
            break;
        }
      });
    }
  }

  handleTokenLoseForPaymentRedirect() {

    let url = document.location.href;
    const token: string | null = sessionStorage.getItem(AppConsts.Session_AccessToken);
    if (!token) {//default
      if (url.includes('/franchise-creation/payfort-confirm')) {
        sessionStorage.setItem(AppConsts.Session_PaymentUrl, url.slice(url.indexOf('/franchise-creation'), -12));
      }
      this._oauthService.events.subscribe((res: { type: any }) => {
        switch (res.type) {
          case "token_received":
            const payment: string | null = sessionStorage.getItem(AppConsts.Session_PaymentUrl);
            if (this.currentLang && payment) {

              let paymentUrl = this.currentLang + payment;
              this._router.navigate([paymentUrl]);
            }
            break;
          default:
            break;
        }
      });
    }
  }

  ngOnInit() {
    //Initiate Idle watch
    this.initiateIdleWatch();
    this.authService.checkIfAdminLoggedIn();
  }

  reset() {
    this.idle.watch();
    //xthis.idleState = 'Started.';
    this.timedOut = false;
  }

  initiateIdleWatch() {
    if (this.authService.checkIfLoggedIn()) {
      this.idle.watch()
      this.timedOut = false;
    }
    else {
      this.idle.stop();
    }
  }

  /**
   * @name changeHtmlAttr
   * @memberof AppComponent
   * @description set HTML tag attr language depending on the current language
   * @param {boolean} isRtl flag to know if current status is rtl or ltr
   * @returns {void}
   */
  private changeHtmlAttr(isRtl: boolean): void {
    if (isRtl) {
      this.renderer.addClass(document.querySelector("html"), "rtl");
      this.renderer.removeClass(document.querySelector("html"), "ltr");
      this.renderer.setAttribute(document.querySelector("html"), "lang", "ar");
    } else {
      this.renderer.addClass(document.querySelector("html"), "ltr");
      this.renderer.removeClass(document.querySelector("html"), "rtl");
      this.renderer.setAttribute(document.querySelector("html"), "lang", "en");
    }
  }

  private setDefautLanguage(lang: string): void {
    this.translate.setDefaultLang(lang ? lang : "ar");
    this.translate.use(lang ? lang : "ar");
    this.languageService.setLang(lang);
    this.changeHtmlAttr(lang === "ar");
  }

  public openConfirmationDialog() {
    this.confirmationDialogService
      .confirm("Please confirm..", "Do you really want to ... ?")
      .then(confirmed => console.log("User confirmed:", confirmed))
      .catch(() =>
        console.log(
          "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)"
        )
      );
  }
}
